import React from "react";
import Modal from "react-modal";
import "@Styles/mandate.css";
import group_exclamation from "../../../Images/Group.svg";

const SessionExpiredModal = ({ isOpen, onLoginAgain }) => {
  return (
    <Modal
      isOpen={isOpen}
      ariaHideApp={false}
      className="session-expired-modal"
      overlayClassName="session-expired-overlay"
    >
      <div className="session-expired-content">
        <div className="session-expired-icon">
          <img
            src={group_exclamation}
            height={70}
            alt="Session Expired"
          />
        </div>
        <h2 className="session-expired-title">Session Expired</h2>
        <p className="session-expired-message">
          Your session has expired. Please login again to continue.
        </p>
        <button className="session-expired-btn" onClick={onLoginAgain}>
          Login Again
        </button>
      </div>
    </Modal>
  );
};

export default SessionExpiredModal;
